import axios from "axios";

export default axios.create({
   baseURL : "https://zyggy-referral.onrender.com/api",
   //baseURL : "http://127.0.0.1:3097/api",
   headers : {
    "Content-Type" : "application/json",
    
   }
})